import React, { useEffect, useState, useRef } from 'react';
import ApexCharts, { ApexOptions } from 'apexcharts';
import { getCSS } from '../../../../assets/ts/_utils';
import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider';
import { useIntl } from 'react-intl';
import { useAuth } from '../../../../../app/modules/auth';
import { getGuidanceResultDecisionChart } from '../../../../../app/modules/guidance/guidances-list/core/_requests';
import { ChartModel, initialChartModel } from '../../../../../_metronic/partials/widgets/charts/_models';
import { useYear } from '../../../../../_metronic/partials/layout/header-menus/YearsManager';
import { RoleModel } from '../../../../../app/modules/auth/core/_models';
import { useTerm } from '../../../layout/header-menus/TermsManager';

type Props = {
  className: string;
  unitId?:number
  customerId?:number
};

const GuidanceResultDecisionChart: React.FC<Props> = ({ className, unitId = undefined, customerId = undefined }) => {
  const [guidanceResultDecisionChart,  setGuidanceResultDecisionChart] = useState<ChartModel | undefined>(initialChartModel);
  const [refreshOnce,  setRefreshOnce] = useState<boolean>(true);
  const chartRef = useRef<HTMLDivElement | null>(null);
  const { mode } = useThemeMode();
  const intl = useIntl();
  const { currentUser, auth } = useAuth();
  const currentYearId = useYear();
  const currentTermId = useTerm();

  useEffect(() => {
    let query = '';
    if(auth?.currentRole===RoleModel.Admin)
    {
      query = "&academicYearId=" + currentYearId
    }
    else if(auth?.currentRole === RoleModel.InstitutionManager)
    {
      query =
        '&institutionId=' +
        currentUser?.institutionId +
        '&academicYearId=' +
        currentYearId +
        '&termId=' +
        currentTermId;
      }
    else if (auth?.currentRole === RoleModel.Customer )
          query = '&customerId=' + currentUser?.customerId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId;
        else if (auth?.currentRole === RoleModel.Person)
          query = '&personId=' + currentUser?.personId + '&academicYearId=' + currentYearId + '&termId=' + currentTermId;
    else
    {
      query =
        '&institutionId=' +
        currentUser?.institutionId +
        '&subinstitutionId=' +
        currentUser?.subinstitutionId +
        '&academicYearId=' +
        currentYearId +
        '&termId=' +
        currentTermId +
        '&employeeId=' +
        currentUser!.employeeId +
        (unitId ? '&unitId=' + unitId : '') +
        (customerId ? '&customerId=' + customerId : '')
      }
      getGuidanceResultDecisionChart(query).then((value) => {
        setGuidanceResultDecisionChart(value);
      });
      setTimeout(function(){
        setRefreshOnce(false)
    }, 1000);
  }, [className,unitId,customerId]);

  

  const refreshMode = () => {
    if (!chartRef.current) {
      return;
    }
    const height = parseInt(getCSS(chartRef.current, 'height'));
    if(guidanceResultDecisionChart)
    {
      const chart = new ApexCharts(chartRef.current, getChartOptions(height, guidanceResultDecisionChart));

      if (chart) {
        chart.render();
      }

      return chart;
    }
  };

  useEffect(() => {
    const chart = refreshMode();

    return () => {
      if (chart) {
        chart.destroy();
      }
    };
  }, [chartRef, mode, guidanceResultDecisionChart, refreshOnce]);

  function getChartOptions(height: number, guidanceResultDecisionChart: ChartModel | undefined): ApexOptions {
    return {
        series: [{
            name: intl.formatMessage({ id: '6fn' }),
            data: guidanceResultDecisionChart?.series1 as Array<number>,
          },{
            name: intl.formatMessage({ id: '6fo' }),
            data: guidanceResultDecisionChart?.series2 as Array<number>,
          }
          ,{
            name: intl.formatMessage({ id: '6fp' }),
            data: guidanceResultDecisionChart?.series3 as Array<number>,
          }],
            chart: {
            height: 350,
            type: 'radar',
            dropShadow: {
              enabled: true,
              blur: 1,
              left: 1,
              top: 1
            }
          },
          stroke: {
            width: 2
          },
          fill: {
            opacity: 0.1
          },
          markers: {
            size: 1
          },
          yaxis: {
  
          },
          dataLabels:{
            enabled: true,
         formatter: (val) => `${val}`
          },
          xaxis: {
            categories: guidanceResultDecisionChart?.categories as Array<string>,
          },
          
            colors: ['#FF4560', '#008FFB', '#00E396'],
          

          };
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{intl.formatMessage({ id: '6fl' })}</span>
          <span className='text-muted fw-semibold fs-7'>{intl.formatMessage({ id: '6fm' })}</span>
        </h3>
      </div>
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body'>
        {/* begin::Chart */}
        <div ref={chartRef} id='kt_charts_widget_3_chart'></div>
        {/* end::Chart */}
      </div>
      {/* end::Body */}
    </div>
  );
};

export { GuidanceResultDecisionChart };
